import { useState } from 'react';
import { useFormik } from 'formik';
import { FORGOT_PASSWORD_INIT_VALUES } from '../../constants/auth';
import { FormInput } from '../FormInput/FormInput';
import { Button } from '../Button/Button';
import { Form } from '../Form/Form';
import { Copy } from '../../copy/Copy';
import { useTheme } from '@mui/material';
import { marginTop16Sx, buttonSx } from '../../styles/Global.style';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { FormContainer } from '../../containers/FormContainer/FormContainer';
import { FORGOT_PASSWORD_VALIDATION_SCHEMA } from '../../validation/auth';

export const ForgotPasswordForm = ({ handleCodeSent }) => {
  const theme = useTheme();
  const { forgotPassword } = useAuth();
  const [message, setMessage] = useState();
  const [isError, setIsError] = useState(false);

  const resetError = () => {
    setTimeout(() => {
      setMessage('');
      setIsError(false);
    }, 3000);
  };

  const formik = useFormik({
    initialValues: FORGOT_PASSWORD_INIT_VALUES,
    validationSchema: FORGOT_PASSWORD_VALIDATION_SCHEMA,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (val) => {
      try {
        await forgotPassword(val.email.toLowerCase());
        handleCodeSent(val.email.toLowerCase());
      } catch (err) {
        setIsError(true);
        setMessage(err.message);
        resetError();
      }
    },
  });

  return (
    <FormContainer title={Copy.generate('ForgotPasswordForm.title')}>
      <Form formik={formik} isError={isError} message={message}>
        <FormInput
          inputFor="email"
          formik={formik}
          labelText={Copy.generate('Inputs.email')}
          inputType="email"
        />
        <Button
          type="submit"
          fullWidth
          text={Copy.generate('Buttons.sendCode')}
          sx={{ ...buttonSx(theme), ...marginTop16Sx }}
        />
      </Form>
    </FormContainer>
  );
};
